import { useRef } from "react";

const buttonsContainerHeight = 68;
const useTableHeight = () => {
  const bottomSectionRef = useRef<HTMLDivElement>(null);

  const calculateMaxHeight = (hasButtons: boolean) => {
    if (bottomSectionRef.current) {
      const offsetHeight = bottomSectionRef.current.offsetHeight;
      const adjustedHeight = hasButtons ? offsetHeight - buttonsContainerHeight : offsetHeight;
      return `${adjustedHeight}px`;
    }
    return "500px";
  };
  return { bottomSectionRef, calculateMaxHeight };
};
export default useTableHeight;
